import { Link } from 'react-router-dom';
import { GRENADA_PARISHES } from '@shopgnd/shared';

/** Full-width location picker — mint band on the homepage. */
export function ShopByParishSection() {
  return (
    <section className="border-y border-brand-100 bg-brand-50 py-10 dark:border-slate-800 dark:bg-brand-950/30">
      <div className="mx-auto max-w-[1400px] px-4 sm:px-6">
        <div className="mb-5 flex items-end justify-between gap-4">
          <div>
            <p className="text-xs font-semibold uppercase tracking-wide text-brand-700 dark:text-brand-400">
              Local delivery
            </p>
            <h2 className="mt-1 text-2xl font-bold text-slate-900 dark:text-white">Shop by location</h2>
          </div>
          <Link
            to="/grenada/shop"
            className="shrink-0 text-sm font-semibold text-brand-700 hover:underline dark:text-brand-400"
          >
            All products →
          </Link>
        </div>
        <div className="grid grid-cols-2 gap-2 sm:grid-cols-3 md:grid-cols-4 lg:grid-cols-6">
          {GRENADA_PARISHES.map((parish) => (
            <Link
              key={parish}
              to={`/grenada/shop?parish=${encodeURIComponent(parish)}`}
              className="rounded-xl border border-slate-200/80 bg-white px-3 py-3 text-center text-sm font-medium text-slate-700 shadow-sm transition hover:border-brand-300 hover:text-brand-800 dark:border-slate-600 dark:bg-slate-900 dark:text-slate-300 dark:hover:border-brand-600"
            >
              {parish}
            </Link>
          ))}
        </div>
      </div>
    </section>
  );
}
